<mat-card>
  <mat-card-title *ngIf="isInRole">Avis SBTCP</mat-card-title>
  <mat-card-subtitle *ngIf="! isInRole">Avis SBTCP</mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="avisFormGroup">
      <div>
        <mat-radio-group formControlName="avis" fxLayoutGap="10px">
          <mat-radio-button *ngFor="let avis of avisObj"
                            [value]="avis.value"> {{avis.label}}&nbsp;</mat-radio-button>
        </mat-radio-group>
      </div>
      <div style="padding-top: 20px;">
        <mat-progress-bar [mode]="'indeterminate'" *ngIf="loadingWinpaye"></mat-progress-bar>
        <div>
          <mat-form-field appearance="outline" fxFlex="30">
            <mat-label>Code WINPAYE</mat-label>
            <mat-select formControlName="winpaye">
              <mat-option *ngFor="let elems of winpayeCodes" [value]="elems.label">
                <span [matTooltip]="elems.label">{{elems.label}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div style="padding-top: 20px;">
        <mat-form-field appearance="outline" fxFlex="80">
          <mat-label>Commentaire SBTCP</mat-label>
          <textarea type="text" rows="3"
                    formControlName="commentaire"
                    matInput placeholder="Votre commentaire pour l'avis"></textarea>
          <mat-hint align="end"><code>{{getCommentaire()?.length}}</code></mat-hint>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
